
/* global google */
import React, { useEffect, useRef, useState } from "react";



import {
  FaEdit,
  FaTrash,
  FaPlus,
  FaMapMarkerAlt,
  FaHome,
  FaBuilding,
  FaTag,
  FaTimes,
} from "react-icons/fa";
import axios from "axios";
import "./Address.css";

const Address = () => {
  // 🔹 NEW
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [addressId, setaddressId] = useState(null);
  const [formData, setFormData] = useState({
    addressLine: "",
    location: "",
    landMark: "",
    pincode: "",
    state: "",
    city: "",
    category: "Home",

    latitude: null,      // 🔹 NEW
    longitude: null,     // 🔹 NEW
    address: "",         // 🔹 NEW
  });

  const categories = [
    { value: "Home", icon: FaHome, color: "#3498db" },
    { value: "Office", icon: FaBuilding, color: "#2ecc71" },
    { value: "Other", icon: FaTag, color: "#e74c3c" },
  ];

  const token = localStorage.getItem("authToken");
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🔹 FETCH SAME AS BEFORE
  const fetchAddresses = async () => {
  try {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) {
      console.error("User ID not found");
      return;
    }

    const res = await axios.get(
      `https://backend.maamaas.com/subscription/api/user/get/addresses/${userId}`,
      {
        headers: token
          ? {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            }
          : {},
      }
    );

    // Check response structure
    if (res?.data) {
      setAddresses(res.data);
    } else {
      console.warn("No data received");
      setAddresses([]);
    }

  } catch (error) {
    console.error("Error fetching addresses:", error?.response || error.message);
  }
};

  useEffect(() => {
    fetchAddresses();
  }, []);

  // 🔹 INIT MAP ONLY WHEN MODAL OPENS
  useEffect(() => {
    if (isOpen && window.google) {
      initMap();
    }
  }, [isOpen]);

  const initMap = () => {
    const defaultLoc = { lat: 20.5937, lng: 78.9629 };

    mapRef.current = new window.google.maps.Map(
      document.getElementById("address-map"),
      { center: defaultLoc, zoom: 14 }
    );

    markerRef.current = new window.google.maps.Marker({
      map: mapRef.current,
      draggable: true,
    });

    markerRef.current.addListener("dragend", (e) => {
      setLatLng(e.latLng.lat(), e.latLng.lng());
    });
  };

  // 🔹 CURRENT LOCATION
  useEffect(() => {
    if (!isOpen) return;

    const initMap = () => {
      const defaultLocation = { lat: 17.385044, lng: 78.486671 }; // Hyderabad

      mapRef.current = new google.maps.Map(
        document.getElementById("address-map"),
        {
          center: defaultLocation,
          zoom: 14,
        }
      );

      markerRef.current = new google.maps.Marker({
        position: defaultLocation,
        map: mapRef.current,
        draggable: true,
      });

      // Initial values
      setLatitude(defaultLocation.lat);
      setLongitude(defaultLocation.lng);

      // 📍 Click on map
      mapRef.current.addListener("click", (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();

        markerRef.current.setPosition({ lat, lng });
        setLatitude(lat);
        setLongitude(lng);
      });

      // 📍 Drag marker
      markerRef.current.addListener("dragend", (e) => {
        setLatitude(e.latLng.lat());
        setLongitude(e.latLng.lng());
      });
    };

    initMap();
  }, [isOpen]);


  // 🔹 REVERSE GEOCODING
  const setLatLng = (lat, lng) => {
    setFormData((p) => ({
      ...p,
      latitude: lat,
      longitude: lng,
    }));

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (res, status) => {
      if (status === "OK" && res[0]) {
        const get = (t) =>
          res[0].address_components.find((c) => c.types.includes(t))
            ?.long_name || "";

        setFormData((p) => ({
          ...p,
          address: res[0].formatted_address,
          city: get("locality"),
          state: get("administrative_area_level_1"),
          pincode: get("postal_code"),
        }));
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const openModal = () => {
    // setAddressId(null);
    setFormData({
      addressLine: "",
      location: "",
      landMark: "",
      pincode: "",
      state: "",
      city: "",
      category: "Home",
      latitude: null,
      longitude: null,
      address: "",
    });
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);



  const useMyLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        setLatitude(lat);
        setLongitude(lng);

        const position = { lat, lng };

        mapRef.current.setCenter(position);
        markerRef.current.setPosition(position);
      },
      () => {
        alert("Unable to fetch your location");
      }
    );
  };

  const handleEdit = (address) => {
    setaddressId(address.addressId || address.id);
    setFormData({
      addressLine: address.addressLine || "",
      location: address.location || "",
      landMark: address.landMark || "",
      pincode: address.pincode || "",
      state: address.state || "",
      city: address.city || "",
      category: address.category || "Home",
    });
    setIsOpen(true);
  };

  const handleDelete = async (addressId) => {
    if (!addressId) {
      alert("❌ Invalid address ID.");
      return;
    }

    const confirmDelete = window.confirm("Are you sure you want to delete this address?");
    if (!confirmDelete) return;

    try {
      await axios.delete(
        `https://backend.maamaas.com/subscription/api/user/delete/${addressId}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );
      alert("✅ Address deleted successfully!");
      fetchAddresses();
    } catch (error) {
      console.error("Error deleting address:", error.response || error.message);
      alert("❌ Failed to delete address.");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const userId = localStorage.getItem("userId");

    // 🔴 IMPORTANT CHECK
    if (latitude == null || longitude == null) {
      alert("Please select location on map to get latitude & longitude");
      setLoading(false);
      return;
    }

    // ✅ Plain address string
    const addressString =
      `doorNumber: ${formData.doorNumber || "null"}, ` +
      `addressLine: ${formData.addressLine}, ` +
      `landMark: ${formData.landMark}, ` +
      `city: ${formData.city}, ` +
      `state: ${formData.state}, ` +
      `pincode: ${Number(formData.pincode)}`;

    const body = {
      userId: Number(userId),

      doorNumber: formData.doorNumber || null,
      addressLine: formData.addressLine,
      landMark: formData.landMark,
      city: formData.city,
      state: formData.state,
      pincode: Number(formData.pincode),
      category: formData.category,

      // 🔥 REQUIRED FOR CART DELIVERY
      latitude: Number(latitude),
      longitude: Number(longitude),

      // backend text field
      address: addressString
    };

    try {
      if (addressId) {
        await axios.put(
          `https://backend.maamaas.com/subscription/api/user/update/${addressId}`,
          body,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
      } else {
        await axios.post(
          `https://backend.maamaas.com/subscription/api/user/location/add`,
          body,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
      }

      fetchAddresses();
      closeModal();

    } catch (error) {
      console.error("❌ Address save failed:", error);
      alert(
        error.response?.data?.message ||
        "Failed to save address"
      );
    } finally {
      setLoading(false);
    }
  };



  const getCategoryIcon = (category) => {
    const categoryObj = categories.find(cat => cat.value === category);
    const IconComponent = categoryObj ? categoryObj.icon : FaTag;
    const color = categoryObj ? categoryObj.color : "#95a5a6";
    return <IconComponent style={{ color }} />;
  };
  /* ================= UI SAME ================= */

  return (
    <div className="address-container">
      <div className="address-header">
        <div className="header-content">
          <FaMapMarkerAlt className="header-icon" />
          <div className="header-text">
            <h2 className="header-title">My Addresses</h2>
            <p className="header-subtitle">Manage your delivery addresses</p>
          </div>
        </div>
        <button className="add-address-btn" onClick={openModal}>
          <FaPlus className="btn-icon" />
          Add New Address
        </button>
      </div>

      {/* ===== MODAL ===== */}
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-contenty">
            <div className="modal-header">
              <h3>{addressId ? "Edit Address" : "Add New Address"}</h3>
              <button className="close-btn" onClick={closeModal}>
                <FaTimes />
              </button>
            </div>

            {/* 🔹 EXTRA FEATURE ONLY */}
            <button
              type="button"
              className="submit-btn"
              onClick={useMyLocation}
            >
              Use My Current Location
            </button>

            <div
              id="address-map"
              style={{ width: "100%", height: "220px", marginBottom: "15px" }}
            />

            {/* ===== ORIGINAL FORM SAME ===== */}
            <form onSubmit={handleSubmit} className="address-form">
  <div className="form-grid">

    <div className="form-group">
      <input
        name="addressLine"
        placeholder="Door / House No *"
        value={formData.addressLine}
        onChange={handleChange}
        required
      />
    </div>

    <div className="form-group">
      <input
        name="landMark"
        placeholder="Landmark *"
        value={formData.landMark}
        onChange={handleChange}
        required
      />
    </div>

    <div className="form-group">
      <input
        name="pincode"
        placeholder="Pincode *"
        value={formData.pincode}
        onChange={handleChange}
        required
      />
    </div>

    <div className="form-group">
      <input
        name="state"
        placeholder="State *"
        value={formData.state}
        onChange={handleChange}
        required
      />
    </div>

    <div className="form-group">
      <input
        name="city"
        placeholder="City *"
        value={formData.city}
        onChange={handleChange}
        required
      />
    </div>

    <div className="form-group">
      <select
        name="category"
        value={formData.category}
        onChange={handleChange}
        required
      >
        <option value="" disabled>
          Address Type *
        </option>
        {categories.map((c) => (
          <option key={c.value} value={c.value}>
            {c.value}
          </option>
        ))}
      </select>
    </div>

  </div>

  <button className="submit-btn" disabled={loading}>
    {addressId ? "Update Address" : "Add Address"}
  </button>
</form>

          </div>
        </div>
      )}
      {!isMobile && (
        <div className="address-table-container">
          <table className="address-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Category</th>
                <th>Landmark</th>
                <th>Door No</th>
                <th>City</th>
                <th>State</th>
                <th>Pincode</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {addresses.map((addr, i) => (
                <tr key={addr.addressId || addr.id}>
                  <td className="serial-number">{i + 1}</td>
                  <td className="category-cell">
                    <div className="category-content">
                      {getCategoryIcon(addr.category)}
                      <span>{addr.category}</span>
                    </div>
                  </td>
                  <td>{addr.landMark || "N/A"}</td>
                  <td>{addr.addressLine || "N/A"}</td>
                  <td>{addr.city || "N/A"}</td>
                  <td>{addr.state || "N/A"}</td>
                  <td className="pincode">{addr.pincode || "N/A"}</td>
                  <td className="actions-cell">
                    <button className="table-btn edit-btn" onClick={() => handleEdit(addr)}>
                      <FaEdit />
                    </button>
                    <button className="table-btn delete-btn" onClick={() => handleDelete(addr.addressId || addr.id)}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Address;


